var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.90306L7.14645 4.6999C7.34171 4.87347 7.65829 4.87347 7.85355 4.6999C8.04882 4.52634 8.04882 4.24493 7.85355 4.07136L4.35355 0.960253C4.15829 0.786686 3.84171 0.786686 3.64645 0.960253L0.146447 4.07136C-0.0488155 4.24493 -0.0488155 4.52634 0.146447 4.6999C0.341709 4.87347 0.658291 4.87347 0.853553 4.6999L4 1.90306Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.7571L7.14645 10.9603C7.34171 10.7867 7.65829 10.7867 7.85355 10.9603C8.04882 11.1338 8.04882 11.4152 7.85355 11.5888L4.35355 14.6999C4.15829 14.8735 3.84171 14.8735 3.64645 14.6999L0.146447 11.5888C-0.0488155 11.4152 -0.0488155 11.1338 0.146447 10.9603C0.341709 10.7867 0.658291 10.7867 0.853553 10.9603L4 13.7571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelect);
export default __webpack_public_path__ + "static/media/arrowSelect.f399a532.svg";
export { ForwardRef as ReactComponent };